import { Component, Input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { BibliothequesService } from 'src/services/bibliotheques.service';
import { ScormPackageModel } from 'src/models/scormPackageModel';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-package-card',
    imports: [MatIconModule],
    templateUrl: './package-card.component.html',
    styleUrl: './package-card.component.scss'
})
export class PackageCardComponent {
  @Input() package!: ScormPackageModel;

  constructor(
    public bibliothequeService: BibliothequesService,
    private translate: TranslateService
  ) { }

  getLocalizedName(): string {
    const locales: { [key: string]: string } = {};

    this.package.locales?.forEach(locale => {
      locales[locale.langue] = locale.titre || '';
    });

    let name = this.bibliothequeService.getNomLocalise(locales);

    if (!this.package.actif) {
      const inactivePrefix = this.translate.instant('LIBRARIES_MANAGEMENT.INACTIVE_PREFIX');
      name = inactivePrefix + name;
    }

    return name;
  }
}
